<div>
	@if (showForm()) {
		@if (edit(); as edit) {
			<nz-tabs>
				<nz-tab nzTitle="Edit Lesson">
					<app-setup-wizard-lesson-form
						[unitUuid]="edit.before!.unit_uuid!"
						[loading]="loading()"
						[edit]="edit.after || edit.before || null"
						(onClear)="onFormClear()"
						(onSubmit)="onFormSubmit($event)"
					></app-setup-wizard-lesson-form>
				</nz-tab>
				<nz-tab nzTitle="Add Activity">
					<app-setup-wizard-activity-form
						[lessonUuid]="edit.before!.lesson_uuid!"
						[loading]="loading()"
						(onClear)="onFormClear()"
						(onSubmit)="onActivityFormSubmit($event)"
					></app-setup-wizard-activity-form>
				</nz-tab>
			</nz-tabs>
		} @else {
			<h1>Edit is missing...</h1>
		}
	} @else {
		<div class="top-buttons">
			<button
				nz-button
				nzType="primary"
				(click)="onAdd()"
				class="add-button"
				[disabled]="true"
				nz-tooltip="To add a new lesson go to the unit tab and edit the unit you want to add the lesson to."
			>
				Add
			</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.lessons"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-lessons-table
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-lessons-table>
</div>
